import { ROLES } from '../../constants/role';
export default {
  //#region token
  [`${ROLES.STUDENT}_TOKEN`]: localStorage.getItem('STUDENT_TOKEN') || '',
  [`${ROLES.TEACHER}_TOKEN`]: localStorage.getItem('TEACHER_TOKEN') || '',
  [`${ROLES.SCHOOL}_TOKEN`]: localStorage.getItem('SCHOOL_TOKEN') || '',
  [`${ROLES.SL}_TOKEN`]: localStorage.getItem('SL_TOKEN') || '',
  lastLoginType: localStorage.getItem('LAST_LOGIN_ROLE') || '',
  //#endregion
  studentLoginData: {},
  teacherLoginData: {},
  schoolLoginData: {},
  slLoginData: null,
  studentStatus: null,
  isShowWelfare: true,
  comData: {},
  comDataReset: {}
};
